import { Input, message } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as AssembleBlackSvg } from "@/commons/icons/panel-icon/assemble-black.svg";
import { graphicStore } from "@/commons/store/graphic-store";
import { LayerType } from "@/commons/enums/layer-type";
import { HVAC_SUB_CONTROL } from "@/passets/hvac-engine/enums/hvac-sub-control";
import { HVAC_SIGNAL } from "@/passets/hvac-engine/enums/hvac-signal";
import { HVAC_CTRL_TYPE } from "@/passets/hvac-engine/enums/hvac-control-type";
import { Circle, ExtrudeSurfaceT, JointPoint, Point, ENTITY_TYPE } from "pytha";
import { Vector3 } from "three";
import { getSpecialPrimitiveLayerUuid } from "@/commons/utils/layer-utils";
import { HvacSuppressorT } from "@/passets/hvac-engine/models/HvacSuppressorT";


const generateSuppressorBlock = (name: string, diameter: number, length: number, layerUuid: string): HvacSuppressorT => {
    // 圆管
    let circle = new Circle(new Point(0, 0, 0), diameter / 2, null, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
    let extrudeSurfaceT = new ExtrudeSurfaceT([circle], new Vector3(0, 0, 1), length);
    let entities = [extrudeSurfaceT];
    let blockT: HvacSuppressorT = new HvacSuppressorT(new Point(0, 0, 0), entities, name, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
    let suppressorJointPoint1: JointPoint = {
        key: "basePoint",
        point: new Vector3(0, 0, 0),
        normal: new Vector3(0, 0, -1),
        axisX: new Vector3(-1, 0, 0)
    }

    let suppressorJointPoint2: JointPoint = {
        key: "upPoint",
        point: new Vector3(0, 0, length),
        normal: new Vector3(0, 0, 1),
        axisX: new Vector3(1, 0, 0)
    }
    blockT.setJointPointList([suppressorJointPoint1, suppressorJointPoint2])
    blockT.layerUuid = layerUuid;
    return blockT
}

export default function HavcDeviceSuppressorPanel() {
    const { projectId, modelUuid } = useParams();
    const MODEL_NAME = "消音器"
    const [diameter, setDiameter] = useState<number>(0);            // 消音器管径
    const [length, setLength] = useState<number>(0);                // 消音器长度
    const [offset, setOffset] = useState<number>(0);                // 相对标高的偏移

    const assemble = () => {
        if (!diameter) {
            message.warning("请输入直径");
            return;
        }

        if (!length) {
            message.warning("请输入长度");
            return;
        }

        getSpecialPrimitiveLayerUuid(projectId, modelUuid, LayerType.SUPPRESSOR).then((layerUuid: string) => {
            // 激活布置构件的二级控制器
            const currentCmdControl = graphicStore.extraContext.getCurrentViewEditor().cmdControl
            if (currentCmdControl) {
                graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
            }

            let data = {
                name: MODEL_NAME,
                comType: LayerType.SUPPRESSOR,
            }
            let blockT: HvacSuppressorT = generateSuppressorBlock(MODEL_NAME, diameter, length, layerUuid);

            currentCmdControl.activateSubCommandControl(HVAC_SUB_CONTROL.ADDHVACDEVICECONTROL.name);
            graphicStore.extraContext.listeners.getSignal(HVAC_SIGNAL.initHvacDeviceControl).dispatch(data, ENTITY_TYPE.HAVC, blockT, offset);
        })

    }

    return (
        <>
            <div className="row compact">
                <div className="label">管径(mm):</div>
                <Input
                    size='small'
                    value={diameter}
                    className="input-box"
                    placeholder='管径(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setDiameter(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">高度(mm):</div>
                <Input
                    size='small'
                    value={length}
                    className="input-box"
                    placeholder='高度(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setLength(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">相对标高偏移(mm):</div>
                <Input
                    size='small'
                    value={offset}
                    className="input-box"
                    placeholder='相对标高偏移(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setOffset(parseFloat(value));
                    }}
                />
            </div>
            <div className='bottom-footer'>
                <div className="ope-btn">
                    <div className="insert-button" onClick={assemble}>
                        <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                        <div className="text">布置</div>
                    </div>
                </div>
            </div>
        </>
    )
}